import classNames from "classnames"
import React from "react"

import GatsbyStoryblokImage from "./GatsbyStoryblokImage"
import Section from "./Section"

type Props = {
  imageUrl: string
  imageAlt: string
  alignment?: "center" | "left"
}

const ImageItem = ({ imageUrl, imageAlt, alignment = "center" }: Props) => {
  return (
    <Section
      className={classNames("relative flex overflow-hidden", {
        "items-center justify-center": alignment === "center",
        "items-start justify-start !px-0": alignment === "left",
      })}
    >
      <GatsbyStoryblokImage
        aspectRatio="fullWidth"
        loadType="eager"
        image={imageUrl}
        alt={imageAlt || "Image item"}
        className="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl"
      />
    </Section>
  )
}

export default ImageItem
